module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "page-contacts"
    }
  }, [_c('clearfix', {
    attrs: {
      "wide": true,
      "bootstrap": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("foobar.beer")]), _vm._v(" "), _c('ul', {
    staticClass: "footer-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about-foobar"
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/foobars"
    }
  }, [_vm._v("Collection")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/privacy-and-license"
    }
  }, [_vm._v("Privacy & License")])], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('clearfix')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("friends")]), _vm._v(" "), _c('ul', {
    staticClass: "footer-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://oldtimers-garage.cz"
    }
  }, [_vm._v("Oldtimers Garage")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://spamalyze.org"
    }
  }, [_vm._v("Spamalyze")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("colleagues")]), _vm._v(" "), _c('ul', {
    staticClass: "footer-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://bouncepilot.com"
    }
  }, [_vm._v("BouncePilot")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://jpower8.com"
    }
  }, [_vm._v("jPower8")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5acdbf92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FooterMenu.vue
// module id = 1835
// module chunks = 1